const search = {
  search: {
    // Button label for the hero search bar.
    search: 'Search',
    // The city chip on /search (?cityId=…), shaped like the district chip below.
    city: {
      chip: 'City: {{name}}',
      clear: 'Clear city',
    },
    // District / neighborhood search
    district: {
      placeholder: 'Search a district…',
      label: 'Search district',
      noResults: 'No matching districts',
      listings_one: '{{count}} listing',
      listings_other: '{{count}} listings',
      chip: 'District: {{name}}',
      clear: 'Clear district',
    },
    // Combined city + district location search (Rightmove-style resolver)
    location: {
      placeholder: 'City or district…',
      label: 'Search city or district',
      noResults: 'No matching locations',
      cityLabel: 'City',
      districtLabel: 'District',
      listings_one: '{{count}} listing',
      listings_other: '{{count}} listings',
      // District-score badge in search suggestions (computed from real listings)
      districtScore: 'District score',
      // Shared district-score vocabulary (map, insights panel, property page)
      districtScoreNone: 'no score',
      districtScoreTooltip: 'Computed from real listings data in this district',
      districtScoreComputedFrom_one: 'Computed from {{count}} real listing in this district',
      districtScoreComputedFrom_other: 'Computed from {{count}} real listings in this district',
      scoreFactors: {
        livability: 'Livability',
        investment: 'Investment',
        family: 'Family fit',
        safety: 'Safety',
      },
    },
    // "Within N km" radius around a selected district
    radius: {
      label: 'Search radius',
      exact: 'This area only',
      within: '+ {{km}} km',
    },
    // AI-powered search features
    smartSuggestions: 'Smart AI Suggestions',
    searching: 'Searching...',
    noResults: 'No results found',
    tryDifferent: 'Try a different search term',
    recent: 'Recent Searches',
    clearRecent: 'Clear',
    popular: 'Popular Searches',
    properties: 'properties',
    tipTitle: 'Smart Search Tip',
    tip: 'Try natural language like "3 bedroom apartment in Riyadh under 10000" for AI-powered results',
    voiceSearch: 'Voice search',
    voiceNotSupported: 'Voice search is not supported in your browser',
    listening: 'Listening...',
    inputLabel: 'Search properties',
    suggestionTypes: {
      property: 'Property',
      city: 'City',
      neighborhood: 'Neighborhood',
      propertyType: 'Property Type',
      amenity: 'Amenity',
      ai: 'AI Suggestion',
    },
    ai: {
      badgeVector: 'AI Search',
      badgeHybrid: 'Smart Search',
      badgeReranked: 'AI-ranked',
      whyMatches: 'Why this matches',
      understood: 'We understood:',
      showingResultsFor: 'Showing results for',
      searchInstead: 'Search instead for the original',
      upgradeTitle: 'Get sharper AI ranking',
      upgradeDescription: 'Subscribers get AI-reranked results and natural-language understanding on top of the free smart search.',
      upgradeCta: 'See plans',
      comingSoon: 'AI Search - Coming soon',
    },
    header: {
      title: 'Find Your Next Home',
      subtitle:
        'Use tailored filters to surface listings that align with your lifestyle, investment horizon, and preferred neighbourhoods.',
    },
    results: {
      count: '{{count}} matching listings',
      // Page header (owner, 2026-10-07: one title, the count once).
      titleRent: 'Properties for rent',
      titleBuy: 'Properties for sale',
      titleAll: 'Properties',
      titleIn: '{{title}} in {{place}}',
      placeDefault: 'Saudi Arabia',
      total: '{{n}} properties',
      total_one: '{{n}} property',
      total_other: '{{n}} properties',
      // The filter bar's pills.
      allFilters: 'All filters',
      pricePill: 'Price',
      done: 'Done',
      // The drawer's «Show 2,510 properties»; {{what}} is the count phrase above (total).
      show: 'Show {{what}}',
      // The mini-map strip above the results.
      inDrawnArea: '{{what}} in your drawn area',
      inPlace: '{{what}} in {{place}}',
      viewOnMap: 'View on map',
      clearArea: 'Clear area',
      countWithQuery: '{{count}} listings for "{{query}}"',
      sortLabel: 'Sort by',
      sortOptions: {
        newest: 'Newest first',
        oldest: 'Oldest first',
        priceLow: 'Price: Low to high',
        priceHigh: 'Price: High to low',
      },
      // How to read the results: «Whole view» is a dense grid of compact cards,
      // «Card view» one full card per property. The hint line sits under the switch.
      viewModes: {
        label: 'View',
        grid: 'Whole view',
        cards: 'Card view',
        map: 'Map',
        list: 'List',
        gridShort: 'Whole',
        cardsShort: 'Cards',
      },
      loading: 'Gathering the best opportunities...',
      loadingMore: 'Loading more properties...',
      allLoaded: 'All properties loaded',
      emptyTitle: 'No properties matched your filters',
      emptyDescription:
        'Try widening the price range, adjusting the location, or clearing your filters to explore more of the market.',
      emptyReset: 'Reset filters',
      summary: '{{count}} properties found',
      toggleFilters: {
        open: 'Advanced filters',
        close: 'Hide filters',
        hint: 'Advanced filters are hidden-tap to refine your search.',
      },
    },
    filters: {
      title: 'Filters',
      subtitle: 'Refine listings to match your brief',
      clear: 'Clear all',
      quickTitle: 'Quick filters',
      quick: {
        under400: 'Under 400K {{currency}}',
        between400And700: '400K - 700K {{currency}}',
        above700: 'Above 700K {{currency}}',
        petFriendly: 'Pet friendly only',
      },
      searchLabel: 'Keyword search',
      searchPlaceholder: 'Try “a family villa with a garden near schools”…',
      resetSearch: 'Clear keyword',
      priceLabel: 'Budget range',
      minPlaceholder: 'Min price',
      maxPlaceholder: 'Max price',
      bedroomsLabel: 'Bedrooms',
      bathroomsLabel: 'Bathrooms',
      anyOption: 'Any',
      propertyTypeLabel: 'Property type',
      propertyTypeOptions: {
        // Residential
        APARTMENT: 'Apartment',
        VILLA: 'Villa',
        DUPLEX: 'Duplex',
        STUDIO: 'Studio',
        PENTHOUSE: 'Penthouse',
        FLOOR: 'Full Floor',
        ROOM: 'Room',
        TOWNHOUSE: 'Townhouse',
        RESIDENTIAL_BUILDING: 'Residential Building',
        REST_HOUSE: 'Rest House',
        CHALET: 'Chalet',
        CONDO: 'Condominium',
        // Land
        LAND: 'Land',
        RESIDENTIAL_LAND: 'Residential Land',
        COMMERCIAL_LAND: 'Commercial Land',
        AGRICULTURAL_LAND: 'Agricultural Land',
        INDUSTRIAL_LAND: 'Industrial Land',
        FARM: 'Farm',
        // Commercial
        OFFICE: 'Office',
        SHOP: 'Shop',
        WAREHOUSE: 'Warehouse',
        SHOWROOM: 'Showroom',
        WORKSHOP: 'Workshop',
        FACTORY: 'Factory',
        COMMERCIAL_BUILDING: 'Commercial Building',
        COMMERCIAL: 'Commercial',
        BUILDING: 'Building',
        // Hospitality & Institutional
        HOTEL: 'Hotel',
        MALL: 'Mall',
        SCHOOL: 'School',
        HEALTH_CENTER: 'Health Center',
        STATION: 'Station',
        // Legacy aliases (for card label lookups - not shown as filter buttons)
        House: 'House',
        Apartment: 'Apartment',
        Condo: 'Condominium',
        Townhouse: 'Townhouse',
        Studio: 'Studio',
        Penthouse: 'Penthouse',
      },
      showMore: 'More filters',
      showLess: 'Fewer filters',
      amenities: {
        parking: 'Covered parking',
        petFriendly: 'Pet friendly',
        furnished: 'Furnished',
        swimmingPool: 'Swimming pool',
        gym: 'Gym',
        garden: 'Garden',
        elevator: 'Elevator',
        security: 'Security',
      },
      activeTitle: 'Active filters:',
      priceChip: 'Budget range',
      // The /search filters panel (PropertyFilters): listing type and category switches.
      listingTypeLabel: 'Listing type',
      listingTypeRent: 'For rent',
      listingTypeBuy: 'For sale',
      listingTypeAll: 'All',
      categoryLabel: 'Category',
      categoryAll: 'All',
      categoryResidential: 'Residential',
      categoryCommercial: 'Commercial',
      // Screen-reader name of the remove button on an «Active filters» chip.
      removeFilter: 'Remove filter: {{label}}',
    },
    card: {
      bedrooms: '{{count}} bedrooms',
      bedrooms_one: '{{count}} bedroom',
      bedrooms_other: '{{count}} bedrooms',
      bathrooms: '{{count}} bathrooms',
      bathrooms_one: '{{count}} bathroom',
      bathrooms_other: '{{count}} bathrooms',
      area: '{{value}} {{unit}}',
      coveredParking: '{{count}} covered space',
      coveredParking_one: '{{count}} covered space',
      coveredParking_other: '{{count}} covered spaces',
      petFriendly: 'Pet friendly',
      furnished: 'Furnished',
      listedOn: 'Listed {{date}}',
      priceAccessible: '{{price}} {{currency}}',
      // The card's photo arrows.
      prevImage: 'Previous photo',
      nextImage: 'Next photo',
      photoOf: 'Photo {{n}} of {{total}}',
      // The result card's call button, and the distance from the landmark picked in «Near».
      call: 'Call',
      distanceFrom: '{{km}} km from {{place}}',
      pricePerSqm: '{{value}} / {{unit}}',
      pricePerSqmAccessible: '{{value}} {{currency}} per {{unit}}',
      viewDetails: 'View details',
      addToFavorites: 'Add to favorites',
      removeFromFavorites: 'Remove from favorites',
      // Whoever posted the listing (owner, broker or company): card tab and fallback name.
      advertiser: 'Advertiser',
      actionDisabled: {
        pending: 'Pending',
        sold: 'Sold',
        rented: 'Rented',
      },
    },
    statuses: {
      available: 'Available',
      pending: 'Pending',
      sold: 'Sold',
      rented: 'Rented',
    },
    map: {
      loading: 'Loading map listings...',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      reset: 'Reset view to show all listings',
      empty: 'No properties to display on the map',
      attribution: 'Map data (c) OpenStreetMap contributors',
      bedrooms: '{{count}} bd',
      bathrooms: '{{count}} ba',
      area: '{{value}} {{unit}}',
      viewProperty: 'View property',
      call: 'Call agent',
      countLabel: '{{count}} listings',
      countLabel_zero: 'No listings on map',
      countLabel_one: '1 listing',
      countLabel_two: '2 listings',
      countLabel_few: '{{count}} listings',
      countLabel_many: '{{count}} listings',
      countLabel_other: '{{count}} listings',
      // Draw to search
      drawToSearch: 'Draw to search',
      drawInstructions: 'Draw a polygon on the map to filter properties within that area',
      clearDrawing: 'Clear drawing',
      propertiesInArea: '{{count}} properties in selected area',
      // Sidebar
      sidebar: {
        title: 'Properties',
        sortByDistance: 'Sorted by distance',
        sortByPrice: 'Sort by price',
        noProperties: 'No properties in this area',
        viewAll: 'View all',
      },
      // Clustering
      cluster: {
        properties: '{{count}} properties',
      },
    },
    // Near You / Landmark Search
    nearYou: {
      title: 'Near Landmark',
      description: 'Find properties near schools, malls, hospitals, and more',
      searchPlaceholder: 'Search for a school, mall, hospital...',
      radiusLabel: 'Search radius',
      radius: {
        '1km': '1 km',
        '3km': '3 km',
        '5km': '5 km',
        '10km': '10 km',
      },
      recentLandmarks: 'Recent searches',
      noResults: 'No landmarks found',
      near: 'Near',
      fromLandmark: 'from {{landmark}}',
      landmarkTypes: {
        school: 'School',
        university: 'University',
        hospital: 'Hospital',
        shopping_mall: 'Mall',
        transit_station: 'Metro',
        park: 'Park',
        mosque: 'Mosque',
        restaurant: 'Restaurant',
        gym: 'Gym',
      },
    },
    // Virtual Tour
    virtualTour: {
      badge: '360°',
      title: 'Virtual Tour',
      enter: 'Enter 360° Tour',
      exit: 'Exit Tour',
      fullscreen: 'Fullscreen',
      exitFullscreen: 'Exit Fullscreen',
      controls: {
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        reset: 'Reset view',
        autoRotate: 'Auto rotate',
      },
      loading: 'Loading virtual tour...',
      error: 'Failed to load virtual tour',
      notAvailable: 'Virtual tour not available',
    },
  },
};

export default search;

